/**
 * @generated SignedSource<<f7812987c99eb313ee276aecd974ba0f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTradeBenefitsContact_tradeFirm$data = {
  readonly rewards: {
    readonly currentProgram: {
      readonly programInfo: {
        readonly code: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useTradeBenefitsContact_tradeFirm";
};
export type useTradeBenefitsContact_tradeFirm$key = {
  readonly " $data"?: useTradeBenefitsContact_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTradeBenefitsContact_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ParentProgram",
          "kind": "LinkedField",
          "name": "currentProgram",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "dffd1465b51b9e06b73bb8c65c8b1e4e";

export default node;
